import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c4f57b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Hieronder staan uw persoonlijke- en correspondentiegegevens. Deze gegevens staan geregistreerd bij uw aannemer.", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "U kunt uw gegevens hieronder veranderen.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Uw e-mailadres en wachtwoord zijn nodig om toegang te krijgen tot Woonon. U ontvangt via dit e-mailadres ook de opdrachtbevestiging en andere berichten.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Persoonlijke gegevens", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Voornaam", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Achternaam", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "E-mailadres", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Correspondentiegegevens", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Alle communicatie omtrent uw bouwnummer verloopt via onderstaande correspondentiegegevens.", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Straat", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Postcode", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Plaats", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Telefoonnummer", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "E-mailadres", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Woonon account", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Gebruikersnaam", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Wachtwoord wijzigen", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Nieuw wachtwoord", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Nieuw wachtwoord bevestigen", -1))

import { useRouter } from 'vue-router'
import { authStore } from '@/stores/auth'
import { computed, onMounted, ref } from 'vue'
import { generalStore } from '@/stores/general'
import PasswordValidator from '@/components/account/PasswordValidator.vue'
import axios from 'axios'


export default /*#__PURE__*/_defineComponent({
  __name: 'Account',
  setup(__props) {

const router = useRouter()
const loading = ref(false)
const changePassword = ref(false)
const password = ref<string|null>(null)
const passwordConfirm = ref<string|null>(null)
const passwordStrongEnough = ref(false)
const errors = computed(() => authStore().errors)

const user = ref<{ firstname:string, lastname:string, email:string, customer: { address:string|null, zipcode:string|null, city:string|null, email:string|null, phone:string|null } }>({
  firstname: authStore().user.firstname,
  lastname: authStore().user.lastname,
  email: authStore().user.email,
  customer: {
    address: null,
    zipcode: null,
    city: null,
    email: null,
    phone: null
  }
})

const requiredFieldsCompleted = computed(() => {
  const minimalRequired = !!(user.value.firstname && user.value.lastname && user.value.email && user.value.customer.phone && user.value.customer.email && user.value.customer.address && user.value.customer.zipcode && user.value.customer.city)

  if (changePassword.value) {
    return (minimalRequired && passwordStrongEnough.value && password.value === passwordConfirm.value)
  }

  return minimalRequired
})

onMounted(() => {
  getCustomerDetails()
})

function getCustomerDetails () : void {
  loading.value = true
  axios.get(process.env.VUE_APP_API_URL + '/customer').then((r) => {
    user.value.customer = r.data
  }).finally(() => {
    loading.value = false
  })
}

function toggleChangePassword () {
  changePassword.value = !changePassword.value

  if (!changePassword.value) {
    password.value = null
    passwordConfirm.value = null
    delete user.value.password
    delete user.value.password_confirmation
  }
}

function updateUser () {
  authStore().clearErrors()
  if (changePassword.value && password.value) {
    user.value.password = password.value
    user.value.password_confirmation = passwordConfirm.value
    authStore().updateUser(user.value).then(() => {
      toggleChangePassword()
    })
  } else {
    authStore().updateUser(user.value)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,4] }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 18, offset: 3}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, { title: "Account" }, {
            extra: _withCtx(() => [
              (_unref(generalStore)().desktop)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Dashboard' })))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Terug naar dashboard")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _hoisted_1,
                      _hoisted_2,
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_4,
              _createVNode(_component_a_row, { gutter: [16,16] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 12}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5,
                      _createVNode(_component_a_input, {
                        type: "text",
                        value: user.value.firstname,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((user.value.firstname) = $event))
                      }, null, 8, ["value"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(errors)['firstname'], (msg, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: index,
                          class: "error-text"
                        }, _toDisplayString(msg), 1))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 12}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6,
                      _createVNode(_component_a_input, {
                        type: "text",
                        value: user.value.lastname,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((user.value.lastname) = $event))
                      }, null, 8, ["value"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(errors)['lastname'], (msg, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: index,
                          class: "error-text"
                        }, _toDisplayString(msg), 1))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 12}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _createVNode(_component_a_input, {
                        type: "text",
                        value: user.value.email,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((user.value.email) = $event))
                      }, null, 8, ["value"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(errors)['email'], (msg, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: index,
                          class: "error-text"
                        }, _toDisplayString(msg), 1))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_8,
              _hoisted_9,
              (!loading.value)
                ? (_openBlock(), _createBlock(_component_a_row, {
                    key: 0,
                    gutter: [16,16]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        xs: {span: 24},
                        sm: {span: 24},
                        md: {span: 24},
                        lg: {span: 12}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10,
                          _createVNode(_component_a_input, {
                            type: "text",
                            value: user.value.customer.address,
                            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((user.value.customer.address) = $event))
                          }, null, 8, ["value"]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(errors)['customer.address'], (msg, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: index,
                              class: "error-text"
                            }, _toDisplayString(msg), 1))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        xs: {span: 24},
                        sm: {span: 24},
                        md: {span: 24},
                        lg: {span: 4}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11,
                          _createVNode(_component_a_input, {
                            type: "text",
                            value: user.value.customer.zipcode,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((user.value.customer.zipcode) = $event))
                          }, null, 8, ["value"]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(errors)['customer.zipcode'], (msg, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: index,
                              class: "error-text"
                            }, _toDisplayString(msg), 1))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        xs: {span: 24},
                        sm: {span: 24},
                        md: {span: 24},
                        lg: {span: 8}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12,
                          _createVNode(_component_a_input, {
                            type: "text",
                            value: user.value.customer.city,
                            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((user.value.customer.city) = $event))
                          }, null, 8, ["value"]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(errors)['customer.city'], (msg, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: index,
                              class: "error-text"
                            }, _toDisplayString(msg), 1))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        xs: {span: 24},
                        sm: {span: 24},
                        md: {span: 24},
                        lg: {span: 12}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_13,
                          _createVNode(_component_a_input, {
                            type: "text",
                            value: user.value.customer.phone,
                            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((user.value.customer.phone) = $event))
                          }, null, 8, ["value"]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(errors)['customer.phone'], (msg, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: index,
                              class: "error-text"
                            }, _toDisplayString(msg), 1))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        xs: {span: 24},
                        sm: {span: 24},
                        md: {span: 24},
                        lg: {span: 12}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_14,
                          _createVNode(_component_a_input, {
                            type: "email",
                            value: user.value.customer.email,
                            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((user.value.customer.email) = $event))
                          }, null, 8, ["value"]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(errors)['customer.email'], (msg, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: index,
                              class: "error-text"
                            }, _toDisplayString(msg), 1))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_a_skeleton, {
                    key: 1,
                    active: ""
                  })),
              _hoisted_15,
              _createVNode(_component_a_row, { gutter: [16,16] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 12}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16,
                      _createElementVNode("p", null, _toDisplayString(_unref(authStore)().user.username), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _hoisted_17,
              _createVNode(_component_a_row, { gutter: [16,16] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, {
                        disabled: _unref(authStore)().restricted(),
                        checked: changePassword.value,
                        onChange: toggleChangePassword
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Ik wil mijn wachtwoord wijzigen.")
                        ]),
                        _: 1
                      }, 8, ["disabled", "checked"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (changePassword.value)
                ? (_openBlock(), _createBlock(_component_a_row, {
                    key: 2,
                    gutter: [16,16]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        xs: {span: 24},
                        sm: {span: 24},
                        md: {span: 24},
                        lg: {span: 12}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_18,
                          _createVNode(_component_a_input_password, {
                            value: password.value,
                            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((password).value = $event))
                          }, null, 8, ["value"]),
                          _createVNode(PasswordValidator, {
                            password: password.value,
                            confirmation: passwordConfirm.value,
                            onPasswordStrengthChanged: _cache[10] || (_cache[10] = ($event: any) => (passwordStrongEnough.value = $event))
                          }, null, 8, ["password", "confirmation"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        xs: {span: 24},
                        sm: {span: 24},
                        md: {span: 24},
                        lg: {span: 12}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_19,
                          _createVNode(_component_a_input_password, {
                            value: passwordConfirm.value,
                            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((passwordConfirm).value = $event))
                          }, null, 8, ["value"]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(errors)['password'], (msg, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: index,
                              class: "error-text"
                            }, _toDisplayString(msg), 1))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_a_button, {
                type: "primary",
                style: {"float":"right"},
                disabled: _unref(authStore)().restricted() || !_unref(requiredFieldsCompleted) || _unref(authStore)().updating,
                loading: _unref(authStore)().updating,
                onClick: updateUser
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Gegevens opslaan")
                ]),
                _: 1
              }, 8, ["disabled", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})